import React, { useState, useEffect } from "react";
// import TableViewSearch from "../TableViewSearch";
import TableView from "../TableView";
import useStyles from "../styles";
// import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
// // import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
// import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
// import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
// import DeleteIcon from "@material-ui/icons/Delete";
// import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
// import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
// import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
// import { ReactComponent as AddQuestionIcon } from "../../../images/examimage/addquestion.svg";
// import { ReactComponent as AddMarksIcon } from "../../../images/examimage/addmarks.svg";
// import { ReactComponent as DashboardIcon } from "../../../images/examimage/dashboard.svg";
// import { ReactComponent as ResultIcon } from "../../../images/examimage/result.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { decryptData } from "../../../crypto";
import { toast } from "react-toastify";
import { IconButton, Popover, Typography, Button, Grid } from "@mui/material";
import {
  fetchTodayExam,
  fetchCurrentTimeApi,
  loginApi,
  instructionLogsApi,
  getLocalIP,
} from "../../../services/service";
import socket from "../../../socket/socket";
import Loader from "../../../components/Loader";
import InstructionPopup from "./InstructionPopup";
import ExamCard from "./ExamCard";
import NoDataFoundImage from "../../../images/noExam.png";

function ViewExam() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [exam, setExam] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openInstructions, setOpenInstructions] = useState(false);
  const [examInstructions, setExamInstructions] = useState();
  const [examInstructionsHindi, setExamInstructionsHindi] = useState();
  const [examId, setExamId] = useState(null);
  const [currentTime, setCurrentTime] = useState(null);

  const handleOpenInstructions = () => {
    setOpenInstructions(true);
  };

  const handleCloseInstructions = () => {
    setOpenInstructions(false);
  };

  const handleClick = (event, rowId, date, time, exam_pin) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
    handleNextClick(date, time, exam_pin);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const handleButtonClickQuestion = (type) => {
  //   navigate(`/admin/${type}`);
  // };

  // Function to delete a book

  // const LightTooltip = withStyles((theme) => ({
  //   tooltip: {
  //     backgroundColor: theme.palette.common.white,
  //     color: "rgba(0, 0, 0, 0.87)",
  //     boxShadow: theme.shadows[1],
  //     fontSize: 11,
  //   },
  // }))(Tooltip);

  const fetchTodayExamData = async () => {
    try {
      const candidateData = await fetchTodayExam();
      setExam(candidateData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const instructionLogs = (examId) => {
    const userId = sessionStorage.getItem("userId");

    getLocalIP(async (ip) => {
      if (ip) {
        const data = {
          exam_id: examId,
          user_id: userId,
          ip,
        };
        try {
          const response = await instructionLogsApi(data);
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      }
    });
  };

  useEffect(() => {
    if (exam.length === 0) {
      fetchTodayExamData();
    }
  }, []);

  function getBaseUrl() {
    const url = new URL(window.location.href);
    return `${url.protocol}//${url.host}/instructions`;
  }

  const startExam = (data) => {
    if (loading) {
      return;
    }

    setLoading(true);
    getLocalIP(async (ip) => {
      if (ip) {
        // try {
        //   const result = await loginApi({ ...data, ip });
        //   if (result.success) {
        //     setLoading(false);
        //     toast.success("Login Successful!");

        //     socket.emit("changeStatus", {
        //       examId: result.examId,
        //       userId: result.userId,
        //       status: "On instructions",
        //     });

        //     const width = window.screen.availWidth;
        //     const height = window.screen.availHeight;
        //  const popup  =  window.open(
        //       getBaseUrl(),
        //       "_blank",
        //       `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`
        //     );

        //     const handleVisibilityChange = () => {
        //       if (popup) {
        //         console.log("🟡 Window minimized or user switched tab");
        //         popup.focus();
        //       } else {
        //         console.log("🟢 Window active again");
        //       }
        //     };

        //     document.addEventListener(
        //       "visibilitychange",
        //       handleVisibilityChange
        //     );

        //     setTimeout(() => {
        //       sessionStorage.clear();
        //       window.location.reload();
        //     }, 3000);
        //   } else {
        //     setLoading(false);
        //     toast.warning(result.message);
        //   }
        // } catch (err) {
        //   setLoading(false);
        //   console.log(err);
        // }
        try {
          const result = await loginApi({ ...data, ip });

          if (result.success) {
            setLoading(false);
            toast.success("Login Successful!");

            socket.emit("changeStatus", {
              examId: result.examId,
              userId: result.userId,
              status: "On instructions",
            });
            const width = window.screen.availWidth;
            const height = window.screen.availHeight;

            const popup = window.open(
              getBaseUrl(),
              "_blank",
              `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`
            );

            // Detect when MAIN window is hidden or loses focus
            const handleVisibilityChange = () => {
              if (document.hidden) {
                if (popup && !popup.closed) {
                  popup.focus(); // bring popup on top
                }
              }
            };

            const handleBlur = () => {
              if (popup && !popup.closed) {
                popup.focus();
              }
            };

            const handleFocus = () => {};

            document.addEventListener(
              "visibilitychange",
              handleVisibilityChange
            );
            window.addEventListener("blur", handleBlur);
            window.addEventListener("focus", handleFocus);

            // Optional cleanup when popup closes
            const interval = setInterval(() => {
              if (!popup || popup.closed) {
                document.removeEventListener(
                  "visibilitychange",
                  handleVisibilityChange
                );
                window.removeEventListener("blur", handleBlur);
                window.removeEventListener("focus", handleFocus);
                clearInterval(interval);
              }
            }, 1000);

            // Example: Clear session after 3s
            setTimeout(() => {
              sessionStorage.clear();
              window.location.reload();
            }, 3000);
          } else {
            setLoading(false);
            toast.warning(result.message);
          }
        } catch (err) {
          setLoading(false);
          console.log(err);
        }
      }
    });
  };

  const fetchCurrentTime = async () => {
    try {
      const response = await fetchCurrentTimeApi();
      if (response.data.success) {
        const cTime = new Date(response.data.currentTime);
        setCurrentTime(cTime);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchCurrentTime();

    const interval = setInterval(fetchCurrentTime, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    socket.connect();
    return () => {
      socket.disconnect();
    };
  }, []);

  const handleNextClick = async (date, time, exam_pin) => {
    try {
      const response = await fetchCurrentTimeApi();
      const currentTime = new Date(response.data.currentTime);

      const [year, month, day] = date.split("-").map(Number);
      const [hours, minutes, seconds] = time.split(":").map(Number);

      const startDateTime = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds
      );
      if (currentTime.getTime() >= startDateTime.getTime()) {
        const userAuth = JSON.parse(sessionStorage.getItem("userAuth"));
        const data = { ...userAuth, exam_pin };
        startExam(data);
      } else {
        toast.warning("You cannot start the exam before the scheduled time.");
      }
    } catch (error) {
      console.error("Error checking exam time:", error);
      toast.error("Failed to verify exam schedule. Please try again.");
    }
  };

  const handleInstructionsClick = (rowId) => {
    exam.map((data) => {
      if (Number(data.id) === Number(rowId)) {
        setExamId(data.id);
        if (
          data.exam_instruction_en !== "undefined" ||
          data.exam_instruction_en !== undefined
        ) {
          setExamInstructions(
            data.exam_instruction_en +
              (data.genral_instruction_en
                ? "<h3>Exam Instructions</h3>" + data.genral_instruction_en
                : "")
          );
        }

        setExamInstructionsHindi(
          data.exam_instruction_hi +
            (data.genral_instruction_hi
              ? "<h3>Exam Instructions</h3>" + data.genral_instruction_hi
              : "")
        );
      }
    });
    instructionLogs(rowId);
    handleOpenInstructions();
  };

  const rows = exam?.map((d, index) => ({
    srno: index + 1,
    id: d.id ? d.id : "N/A",
    exam_name: d.exam_name ? d.exam_name : "N/A",
    start_date: d.start_date ? d.start_date : "N/A",
    duration: d.duration ? d.duration : "N/A",
    start_time: d.start_time ? d.start_time : "N/A",
    exam_pin: d.exam_pin ? d.exam_pin : null,
    end_time: d.end_time ? d.end_time : null,
    status: d.status ? d.status : null,
  }));

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 20,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_name",
      headerName: "Exam Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 400,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      // valueGetter: (params) =>
      //   params.value.charAt(0).toUpperCase() + params.value.slice(1),
    },

    {
      field: "start_date",
      headerName: "Start Date",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => (
        <div>
          {new Date(cellValues.row.start_date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
          })}
        </div>
      ),
    },

    {
      field: "duration",
      headerName: "Duration",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "start_time",
      headerName: "Start Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "active_status",
      headerName: "STATUS",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 300,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <Typography
              className={`${classes.w15} ${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
              aria-describedby={id}
            >
              {/* <Typography> */}
              {cellValues.row.status === "submitted" ? (
                <Typography style={{ color: "green", fontWeight: 600 }}>
                  Completed
                </Typography>
              ) : (
                <div
                  className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifyspacebetween}`}
                >
                  <Button
                    onClick={(event) => {
                      exam.map((data) => {
                        if (Number(data.id) === Number(cellValues.row.id)) {
                          setExamId(data.id);
                          if (
                            data.exam_instruction_en !== "undefined" ||
                            data.exam_instruction_en !== undefined
                          ) {
                            setExamInstructions(
                              (data.genral_instruction_en
                                ? "<h3>Exam Instructions</h3>" +
                                  data.genral_instruction_en
                                : "") + data.exam_instruction_en
                            );
                          }

                          setExamInstructionsHindi(
                            (data.genral_instruction_hi
                              ? "<h3>Exam Instructions</h3>" +
                                data.genral_instruction_hi
                              : "") + data.exam_instruction_hi
                          );
                        }
                      });
                      instructionLogs(cellValues.row.id);
                      handleOpenInstructions();
                    }}
                    style={{ marginRight: "10px" }}
                    variant="contained"
                  >
                    instruction
                  </Button>
                  <Button
                    onClick={(event) => {
                      handleClick(
                        event,
                        cellValues.row.id,
                        cellValues.row.start_date,
                        cellValues.row.start_time,
                        cellValues.row.exam_pin
                      );
                    }}
                    variant="contained"
                  >
                    {cellValues.row.status === "resume" ? "resume" : "Start"}
                  </Button>
                </div>
              )}
              {/* </Typography> */}
            </Typography>
          </div>
        );
      },
    },
  ];

  const style = [
    {
      height: "h80vh",
      style: "viewtable",
      footer: false,
    },
  ];
  return (
    <>
      {loading && <Loader />}
      {/* <ToastContainer /> */}
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        {/* <TableViewSearch Heading={Heading} onSearch={handleSearch} /> */}
        {/* <TableView columns={columns} rows={rows} Heading={style} /> */}
        {/* <Grid
          container
          spacing={2}
          // justifyContent="center"
          // alignItems="center"
          // sx={{ minHeight: "100vh" }} // centers vertically also
          padding={2}
        >
          <Grid item xs={12}>
            <ExamCard
              exam={{
                name: "Mathematics Exam",
                startDate: "15 Sept 2025",
                startTime: "10:00 AM",
                duration: "2 hours",
              }}
            />
          </Grid>
          
        </Grid>{" "} */}

        <div
          style={{
            // backgroundColor:"red",
            padding: "20px",
          }}
        >
          {rows.length === 0 ? (
            <div>
              <img
                src={NoDataFoundImage}
                height={300}
                style={{ opacity: 0.5, margin: "auto", display: "block" }}
                alt=""
              />
            </div>
          ) : (
            rows.map((exam) => (
              <div key={exam.id}>
                <ExamCard
                  exam={exam}
                  handleClick={handleClick}
                  handleInstructionsClick={handleInstructionsClick}
                  currentTime={currentTime}
                />
              </div>
            ))
          )}
        </div>

        <InstructionPopup
          openInstructions={openInstructions}
          handleCloseInstructions={handleCloseInstructions}
          examInstructions={examInstructions}
          examInstructionsHindi={examInstructionsHindi}
          examId={examId}
        />
      </div>
    </>
  );
}
export default ViewExam;
